<template>
    <div class="person_wrapper">
        <div class="person_image">
            <div
                v-full-background-image-path="person.featuredImage"
                class="image bg_image cover"
            />
        </div>

        <div class="person_name">
            {{ person.fullName }}
        </div>

        <div class="leadership_title second_font">
            {{ person.position }}
        </div>

        <a class="btn_email" @click="$emit('contact-us', person.email)">
            צור קשר
        </a>
    </div>
</template>

<script>
export default {
    props: {
        person: {
            type: Object,
            required: true
        }
    }
};
</script>
